// extracted by mini-css-extract-plugin
export default {"root":"left-nav_root__tObnk"};